<template>
  <a-popover :title="false">
    <template slot="content">
      <div class="p-all">
        <div>
          {{ $t("Import seg") }}
        </div>
        <div>
          <a-divider />
          {{ $t("Import seg about") }}
        </div>
      </div>
    </template>
    <span
      class="tool-group-btn without-arrow"
      v-bind:class="{
        'tool-group-btn__active': false,
        'tool-group-btn__disabled': false,
      }"
      @click="openFiles()"
    >
      <span class="tool-group-btn__item tool-group-btn__icon">
        <i class="fa-light fa-file-arrow-up" aria-hidden="true"></i>
      </span>
    </span>
    <input type="file" style="display: none" ref="input" @change="readFiles" />
  </a-popover>
</template>

<script>
export default {
  methods: {
    openFiles() {
      this.$refs.input.click();
    },
    readFiles(e) {
      this.$root.$emit("importSeg", [e.target.files[0]]);
    },
  },
};
</script>
